/**
 * Form Validation Handler
 *
 * Adds 'was-validated' class to forms after first submit attempt.
 * This enables CSS to show validation errors (red borders/underlines) only after submission.
 *
 * Works with HTML5 validation (required, pattern, minlength, etc.)
 */

(function () {
  "use strict";

  /**
   * Initialize validation on all forms
   */
  function initFormValidation() {
    const forms = document.querySelectorAll(
      'form:not([data-form-validation="skip"])',
    );

    forms.forEach((form) => {
      // Disable browser's native validation popups
      form.setAttribute("novalidate", "novalidate");

      form.addEventListener(
        "submit",
        function (event) {
          // Check validity ONCE and store result
          const isValid = this.checkValidity();

          // If form is invalid, prevent submission FIRST
          if (!isValid) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }

          // ALWAYS add was-validated class (even if valid)
          this.classList.add("was-validated");
        },
        false,
      );
    });
  }

  // Initialize on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFormValidation);
  } else {
    initFormValidation();
  }

  // Re-initialize for Shopify Theme Editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", initFormValidation);
  }
})();
